<template>
	<div v-if="item">
		<Layout :navFixed="true" :loading="loading"  :withImage="true" >
			<!-- <Layout :navFixed="false" :loading="loading"> -->

			<div class="header-image header-image-default" v-if="!loading">{{item.title}}</div>

			<div class="container " v-if="!loading">
				<div class="row mt-4 mb-4">
					<div class="col-12">
						<div class="p-4 mt-4 mb-4">
							<div v-html="item.intro"></div>

							<div v-html="item.body"></div>
						</div>
					</div>

					<!-- <div v-if="item.image" class="col-12 col-lg-7 d-none d-md-block">
						<div class="p-4">
							<img :src="item.image.url" class="img-fluid hover-effect" />
						</div>
					</div> -->
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import Layout from '@/components/Layout'
import gql from 'graphql-tag'

export default {
	name: 'Section',
	metaInfo() {
		return {
			title: this.item ? this.item.title : '',
		}
	},
	components: {
		Layout,
	},
	data() {
		return {
			item: {},
			loading: true,
		}
	},
	beforeMount() {
		if (this.$route.params.slug) {
			this.load()
		}
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($slug: String) {
							page(slug: $slug) {
								id
								title
								intro
								body
								image {
									id
									type
									filename
									url
									urlThumb
								}
							}
						}
					`,
					variables: { slug: this.$route.params.slug },
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.item = data.page
					this.loading = false
				})
				.catch((err) => {
					console.log(err)
					this.$router.push('/')
				})
		},
	},
}
</script>

<style scoped>
.container{
	padding-bottom:140px;
}
</style>
